module.exports = __webpack_public_path__ + "img/teams_no_folder_selected.3b5781f0.svg";